<!--
 * @FileDescription: 订单退款成功页面
 * @Author: 陈文景
 * @Date: 2022-11-07 09:42:30
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div>
    <Web v-if="isPC" />

    <Mobile v-else />
  </div>
</template>

<script>
import Web from './web/index.vue'
import Mobile from './mobile/index.vue'

export default {
  components: {
    Web,
    Mobile
  }
}
</script>
